import React, { useCallback } from "react";

import { Button } from "~/ui";
import Modal from "~/ui/Modal";

import type { HomePanelGroup_group$data as HomePanelGroup } from "~/__generated__/HomePanelGroup_group.graphql";

export type ModalData = {
	delete: boolean;
};

type ModalProps = {
	onClose: (result?: ModalData) => void;
	group: HomePanelGroup;
};

export default function DeleteGroupModal(props: ModalProps) {
	const { onClose, group } = props;

	const cancel = useCallback(() => {
		onClose();
	}, [onClose]);

	const deleteGroup = useCallback(() => {
		onClose({
			delete: true,
		});
	}, [onClose]);

	return (
		<Modal onClose={cancel}>
			<Modal.Header onClose={cancel}>
				<Modal.Title>Delete group?</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>
					Series and tags in <strong>{group.name}</strong> will be unaffected and accessible through the search page.
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" size="normal" onClick={cancel}>
					Cancel
				</Button>
				<Button variant="destructive" size="normal" onClick={deleteGroup}>
					Delete
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
